import { __awaiter, __generator } from "tslib";
import React, { useState, useEffect } from 'react';
import { getClientConfig } from '../utils/app-storage';
import { config } from '../config';
var cfg = getClientConfig();
var defaultMessage = 'Updated Chat version deployed - please refresh your browser to resume the conversation.';
var NEW_VERSION_MESSAGE = cfg.NEW_VERSION_MESSAGE || defaultMessage;
var NEW_VERSION_CHECK_INTERVAL = parseInt(cfg.NEW_VERSION_CHECK_INTERVAL) || 60000;
export var NewVersionCheck = function () {
    var _a = useState(null), appVersion = _a[0], setAppVersion = _a[1];
    var _b = useState(false), isUpdateAvailable = _b[0], setIsUpdateAvailable = _b[1];
    var checkAppVersion = function () { return __awaiter(void 0, void 0, void 0, function () {
        var testFileUrl, response, data, newAppVersion, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    testFileUrl = "".concat(cfg.PUBLIC_URL, "/health");
                    return [4 /*yield*/, fetch(testFileUrl, {
                            method: 'GET',
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 5];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    newAppVersion = data.version;
                    if (appVersion === null) {
                        setAppVersion(newAppVersion);
                    }
                    else if (appVersion !== newAppVersion) {
                        setIsUpdateAvailable(true);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    console.log('Error parsing JSON response from health endpoint');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, checkAppVersion()];
                    case 1:
                        _a.sent(); // Check & Set AppVersion on component mount
                        return [2 /*return*/];
                }
            });
        }); })();
        var interval = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, checkAppVersion()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, NEW_VERSION_CHECK_INTERVAL);
        return function () { return clearInterval(interval); };
    }, [appVersion]);
    var message = NEW_VERSION_MESSAGE;
    if (isUpdateAvailable) {
        return React.createElement("div", { className: config.css.B('-new-version-info') }, message);
    }
    return null;
};
